/* BEXO · Mata Hongos — interacciones */
(function () {
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-bx-acc]').forEach(function (acc) {
      if (!once(acc, 'bxAcc')) return;
      var items = acc.querySelectorAll('.bx-acc__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.bx-acc__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('.bx-acc__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-bx-tabs]').forEach(function (tabs) {
      if (!once(tabs, 'bxTabs')) return;
      var btns = tabs.querySelectorAll('.bx-tabs__btn');
      var panels = tabs.querySelectorAll('.bx-tabs__panel');
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('is-active');
        });
      });
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-bx-gallery]').forEach(function (g) {
      if (!once(g, 'bxGallery')) return;
      var main = g.querySelector('.bx-gallery__main img');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.bx-gallery__thumb'));
      if (!main || !thumbs.length) return;
      var index = 0;
      function show(i) {
        index = (i + thumbs.length) % thumbs.length;
        var t = thumbs[index];
        main.src = t.dataset.full;
        main.removeAttribute('srcset');
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = g.querySelector('.bx-gallery__nav--prev');
      var next = g.querySelector('.bx-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      var startX = null;
      g.querySelector('.bx-gallery__main').addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      g.querySelector('.bx-gallery__main').addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      });
    });
  }

  function initPacks(root) {
    root.querySelectorAll('[data-bx-packs]').forEach(function (form) {
      if (!once(form, 'bxPacks')) return;
      var packs = form.querySelectorAll('.bx-pack');
      var saving = form.querySelector('[data-bx-saving]');
      var sticky = document.querySelector('[data-bx-sticky-price]');
      function update() {
        packs.forEach(function (p) {
          var input = p.querySelector('input');
          p.classList.toggle('is-selected', input.checked);
          if (input.checked) {
            if (saving) {
              var s = p.dataset.saving;
              saving.style.display = s ? 'flex' : 'none';
              if (s) saving.querySelector('span').textContent = s;
            }
            if (sticky) sticky.textContent = p.dataset.label;
          }
        });
      }
      packs.forEach(function (p) { p.querySelector('input').addEventListener('change', update); });
      update();
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-bx-sticky]');
    if (!bar || bar.dataset.bxReady) return;
    bar.dataset.bxReady = '1';
    document.body.classList.add('bx-has-sticky');
    var target = document.querySelector(bar.dataset.watch || '[data-bx-watch]');
    if (!target || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && below);
      });
    }, { threshold: 0 }).observe(target);
    var btn = bar.querySelector('[data-bx-sticky-buy]');
    if (btn) {
      btn.addEventListener('click', function (ev) {
        var form = document.querySelector('[data-bx-packs]');
        if (form) {
          ev.preventDefault();
          var submit = form.querySelector('button[value="/checkout"]');
          if (submit) submit.click(); else form.submit();
        }
      });
    }
  }

  function init(root) {
    root = root || document;
    initAccordions(root);
    initTabs(root);
    initGallery(root);
    initPacks(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
